/* IZU Paros: reserve-for-your-visit form. Validates, builds a readable message for the shop, then submits Shopify's contact form. */
(() => {
  const root = document.querySelector("[data-rv]");
  if (!root) return;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const KEY = "izu-reserve";
  const store = {
    get() { try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch (e) { return null; } },
    set(v) { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ } },
    clear() { try { sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ } }
  };

  // ---------- Date in words (UTC, so the day never shifts with the visitor's timezone) ----------
  const parseISO = s => { const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || ""); if (!m) return null; const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])); return d.getUTCFullYear() === +m[1] && d.getUTCMonth() === +m[2] - 1 && d.getUTCDate() === +m[3] ? d : null; };
  const fmt = new Intl.DateTimeFormat("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
  const words = (iso, withYear) => {
    const d = parseISO(iso); if (!d) return "";
    const p = {}; fmt.formatToParts(d).forEach(x => { p[x.type] = x.value; });
    return `${p.weekday}, ${p.day} ${p.month}${withYear ? " " + p.year : ""}`;
  };
  window.izuReserveDateWords = words; // used by the local test only

  // ---------- Done / error states ----------
  const done = $("[data-rv-done]");
  if (done) {
    const s = store.get(), list = $("[data-rv-summary]", done);
    if (s && list) {
      const rows = [["Piece", s.piece], ["Options", s.options], ["Boutique", s.boutique], ["Arrival", s.arrival], ["Arrival time", s.time]].filter(r => r[1]);
      list.innerHTML = rows.map(r => `<li><span>${r[0]}</span><span></span></li>`).join("");
      $$("li", list).forEach((li, i) => { li.lastElementChild.textContent = rows[i][1]; });
      list.hidden = !rows.length;
    }
    store.clear();
    done.focus({ preventScroll: false });
    return;
  }

  const form = $("#ContactForm");
  if (!form) return;
  const pieceInputs = $$('input[name="rv-piece"]');
  const optsStep = $('[data-rv-step="options"]');
  const dateInput = $("#rv-date"), timeInput = $("#rv-time"), wordsEl = $("[data-rv-date-words]");
  const openTime = root.dataset.openTime || "11:00", closeTime = root.dataset.closeTime || "23:00";
  const submitBtn = $("[data-rv-submit]");
  const summaryErr = $("[data-rv-summary-error]");
  const errEl = k => $(`[data-rv-error="${k}"]`);
  const checked = name => $(`input[name="${name}"]:checked`);
  let submitting = false;

  function selectedPiece() { const c = checked("rv-piece"); return c ? { handle: c.value, title: c.dataset.title } : null; }
  const placeholder = $("[data-rv-placeholder]"), chosenEl = $("[data-rv-chosen]");
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  function showOptions() {
    const p = selectedPiece();
    optsStep.disabled = !p;
    if (placeholder) placeholder.hidden = !!p;
    $$("[data-rv-opts]").forEach(d => { d.hidden = !p || d.dataset.rvOpts !== p.handle; });
    if (chosenEl) chosenEl.textContent = p ? ": " + p.title : "";
  }

  // ---------- Deep link to a piece that isn't one of the curated cards (e.g. "Reserve" on any sold-out product):
  // fetch it from the Ajax API and add it to the front of the rail as a normal, pre-selected card, with its own
  // size / colour pills — so validation, the recap and the email all treat it like any other piece. ----------
  function addLinkedPiece(handle) {
    const rail = $("[data-rv-rail]"), optsErr = $('[data-rv-error="options"]');
    if (!rail || !optsErr) return;
    const esc = t => String(t == null ? "" : t).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: "application/json" } })
      .then(r => (r.ok ? r.json() : null))
      .then(prod => {
        if (!prod || pieceInputs.some(i => i.value === prod.handle)) return;
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
        let price = "";
        try { price = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: "currency", currency: cur }).format(prod.price / 100).replace(/[.,]00(?=\D*$)/, ""); } catch (e) { /* no price */ }
        const img = prod.featured_image ? `<img src="${esc(prod.featured_image + (String(prod.featured_image).includes("?") ? "&" : "?") + "width=600")}" alt="${esc(prod.title)}" loading="eager" width="600" height="800">` : "";
        const card = document.createElement("label");
        card.className = "rv__card rv__card--linked";
        card.innerHTML = `<input class="rv__radio" type="radio" name="rv-piece" value="${esc(prod.handle)}" data-title="${esc(prod.title)}" data-rv-ui required>` +
          `<span class="rv__card-img">${img}<span class="rv__check" aria-hidden="true"></span></span>` +
          `<span class="rv__card-name product-title product-title--small">${esc(prod.title)}</span><span class="rv__card-price">${esc(price)}</span><span class="rv__sel" aria-hidden="true">Selected</span>`;
        rail.prepend(card);

        const box = document.createElement("div");
        box.className = "rv__opts"; box.dataset.rvOpts = prod.handle; box.hidden = true;
        const opts = (prod.options || []).filter(o => !(o.name === "Title" && (o.values || []).length === 1));
        box.innerHTML = opts.length ? opts.map((o, oi) => `<fieldset class="rv__group" data-rv-option="${esc(o.name)}"><legend class="rv__group-label">${esc(o.name)}</legend><div class="rv__pills">` +
          (o.values || []).map((v, vi) => { const id = `rv-${esc(prod.handle)}-${oi}-${vi}`; return `<input class="rv__pill-input" type="radio" id="${id}" name="rv-opt-${esc(prod.handle)}-${oi}" value="${esc(v)}" data-rv-ui><label class="rv__pill" for="${id}">${esc(v)}</label>`; }).join("") +
          "</div></fieldset>").join("") : '<p class="rv__note">This piece has no size or colour options.</p>';
        optsErr.before(box);

        const input = card.querySelector("input");
        pieceInputs.unshift(input);
        input.addEventListener("change", () => { showOptions(); clear("pieces"); recap(); });
        $$("input", box).forEach(i => i.addEventListener("change", () => { clear("options"); recap(); }));
        input.checked = true;
        showOptions(); recap();
        rail.scrollTo({ left: 0 });
      })
      .catch(err => { console.warn("IZU reserve: could not add the linked piece", err); });
  }

  // ---------- Deep link from a product page: ?product=<handle> preselects that piece, if it's one of the curated ones ----------
  try {
    const wanted = new URLSearchParams(location.search).get("product");
    if (wanted) {
      const pi = pieceInputs.find(i => i.value === wanted);
      if (pi) { pi.checked = true; showOptions(); }
      else if (/^[a-z0-9][a-z0-9-]*$/i.test(wanted)) addLinkedPiece(wanted);
    }
    const wantedShop = (new URLSearchParams(location.search).get("boutique") || "").toLowerCase();
    const bi = wantedShop && $('input[name="rv-boutique"]').find(i => i.value.toLowerCase() === wantedShop);
    if (bi) { bi.checked = true; bi.dispatchEvent(new Event("change", { bubbles: true })); }
  } catch (e) { /* ignore */ }

  function optionsOf(handle) {
    const box = $(`[data-rv-opts="${handle}"]`); if (!box) return { groups: [], text: "" };
    const groups = $$("[data-rv-option]", box).map(g => { const c = $("input:checked", g); return { name: g.dataset.rvOption, value: c ? c.value : "", el: $("input", g) }; });
    return { groups, text: groups.map(g => `${g.name}: ${g.value}`).join(" / ") };
  }
  function updateWords() {
    const v = dateInput.value;
    wordsEl.textContent = v && parseISO(v) ? words(v, false) : "";
  }

  // ---------- Arrival day: the next 14 days as chips, plus "Other date" (native field) ----------
  const chipsEl = $("[data-rv-chips]"), otherWrap = $("[data-rv-date-other]");
  const fWd = new Intl.DateTimeFormat("en-GB", { weekday: "short", timeZone: "UTC" }), fMo = new Intl.DateTimeFormat("en-GB", { month: "short", timeZone: "UTC" });
  const openFrom = dateInput.dataset.openFrom, openUntil = dateInput.dataset.openUntil;
  const outOfSeason = iso => !!((openFrom && iso < openFrom) || (openUntil && iso > openUntil));
  const addDays = (iso, n) => { const d = parseISO(iso); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
  function buildChips() {
    const today = root.dataset.today; if (!chipsEl || !parseISO(today)) return;
    let html = "";
    for (let i = 0; i < 14; i++) {
      const iso = addDays(today, i), d = parseISO(iso), closed = outOfSeason(iso);
      html += `<input class="rv__chip-input" type="radio" name="rv-date-chip" id="rv-chip-${iso}" value="${iso}" data-rv-ui${closed ? ' aria-disabled="true"' : ""}><label class="rv__chip${closed ? " is-closed" : ""}" for="rv-chip-${iso}"><span>${fWd.format(d)}</span><strong>${d.getUTCDate()}</strong><span>${fMo.format(d).slice(0, 3)}</span></label>`;
    }
    html += `<input class="rv__chip-input" type="radio" name="rv-date-chip" id="rv-chip-other" value="other" data-rv-ui><label class="rv__chip rv__chip--other" for="rv-chip-other">Other date</label>`;
    chipsEl.innerHTML = html;
  }
  function setDate(iso) {
    const chip = iso && $(`input[name="rv-date-chip"][value="${iso}"]`);
    if (chip) { chip.checked = true; otherWrap.hidden = true; dateInput.value = iso; }
    else if (iso) { const o = $("#rv-chip-other"); if (o) o.checked = true; otherWrap.hidden = false; dateInput.value = iso; }
    updateWords(); recap();
  }
  buildChips();
  if (chipsEl) {
    chipsEl.addEventListener("click", e => {
      const inp = e.target.closest && e.target.closest("input.rv__chip-input");
      if (inp && inp.getAttribute("aria-disabled") === "true") { e.preventDefault(); const er = errEl("date"); if (er) er.textContent = dateInput.dataset.closed || "Our boutiques are closed on that date. Please choose another day."; }
    });
    chipsEl.addEventListener("change", e => {
      const inp = e.target; if (!inp || inp.name !== "rv-date-chip") return;
      if (inp.value === "other") { otherWrap.hidden = false; dateInput.value = ""; }
      else { otherWrap.hidden = true; dateInput.value = inp.value; }
      updateWords(); recap(); clear("date");
    });
  }

  // ---------- Recap ("Your request") ----------
  function recap() {
    const set = (k, v) => { const el = $(`[data-rv-recap="${k}"]`); if (!el) return; el.textContent = v || "\u2014"; el.classList.toggle("is-empty", !v); };
    const p = selectedPiece(), b = checked("rv-boutique"), d = dateInput.value;
    set("piece", p ? p.title : "");
    if (p) { const o = optionsOf(p.handle); set("options", o.groups.length ? o.groups.map(g => g.value).filter(Boolean).join(" / ") : "No options"); } else set("options", "");
    set("boutique", b ? b.value : "");
    set("arrival", parseISO(d) ? words(d, false) : "");
    set("time", timeInput && timeInput.value ? timeInput.value : "");
    if (typeof syncHidden === "function") syncHidden();
  }

  // ---------- Piece rail: "1 / 5" counter and keyboard focus scrolls the card into view ----------
  const rail = $("[data-rv-rail]"), countEl = $("[data-rv-count]"), cards = $$(".rv__card");
  function updateCount() {
    if (!rail || !countEl || !cards.length) return;
    const scrolls = rail.scrollWidth > rail.clientWidth + 2;
    if (!scrolls) { countEl.textContent = ""; return; }
    const step = cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 14);
    countEl.textContent = `${Math.min(cards.length, Math.round(rail.scrollLeft / step) + 1)} / ${cards.length}`;
  }
  if (rail) {
    rail.addEventListener("scroll", updateCount, { passive: true });
    window.addEventListener("resize", updateCount);
    pieceInputs.forEach(i => i.addEventListener("focus", () => {
      if (rail.scrollWidth <= rail.clientWidth + 2) return;
      const c = i.closest(".rv__card"), pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      rail.scrollTo({ left: Math.max(0, c.offsetLeft - pad), behavior: reduce.matches ? "auto" : "smooth" });
    }));
  }

  pieceInputs.forEach(i => i.addEventListener("change", () => {
    showOptions(); clear("pieces"); recap();
    if (optsStep.getBoundingClientRect().top > window.innerHeight * 0.5) optsStep.scrollIntoView({ behavior: reduce.matches ? "auto" : "smooth", block: "start" });
  }));
  dateInput.addEventListener("input", () => { updateWords(); recap(); clear("date"); });
  if (timeInput) { const onTime = () => { recap(); clear("time"); }; timeInput.addEventListener("input", onTime); timeInput.addEventListener("change", onTime); }
  dateInput.addEventListener("change", () => { updateWords(); recap(); clear("date"); });
  $$('input[name="rv-boutique"]').forEach(i => i.addEventListener("change", () => { clear("boutique"); recap(); }));
  $$("[data-rv-opts] input").forEach(i => i.addEventListener("change", () => { clear("options"); recap(); }));
  ["rv-name", "rv-email", "rv-consent"].forEach(id => { const el = document.getElementById(id); if (el) el.addEventListener("input", () => clear(id.replace("rv-", ""))); });

  function clear(k) { const e = errEl(k); if (e) e.textContent = ""; }
  function fail(k, msg, focusEl, list) { const e = errEl(k); if (e) e.textContent = msg; if (focusEl) focusEl.setAttribute("aria-invalid", "true"); list.push({ k, focusEl }); }

  function validate() {
    $$("[aria-invalid]").forEach(el => el.removeAttribute("aria-invalid"));
    $$("[data-rv-error]").forEach(e => { e.textContent = ""; });
    const bad = [];
    const p = selectedPiece();
    if (!p) fail("pieces", "Please choose a piece.", pieceInputs[0], bad);
    if (p) {
      const o = optionsOf(p.handle), miss = o.groups.find(g => !g.value);
      if (miss) fail("options", `Please choose a ${miss.name.toLowerCase()}.`, miss.el, bad);
    }
    if (!checked("rv-boutique")) fail("boutique", "Please choose the boutique where you would like to try it on.", $("#rv-b-parikia"), bad);
    const d = dateInput.value, min = root.dataset.today, max = root.dataset.max;
    const from = dateInput.dataset.openFrom, until = dateInput.dataset.openUntil;
    if (!parseISO(d)) fail("date", "Please choose your arrival day.", dateInput, bad);
    else if (d < min || d > max) fail("date", `Please choose a day between ${words(min, true)} and ${words(max, true)}.`, dateInput, bad);
    else if ((from && d < from) || (until && d > until)) fail("date", dateInput.dataset.closed || "Our boutiques are closed on that date. Please choose another day.", dateInput, bad);
    if (timeInput) {
      const tv = timeInput.value;
      if (!/^\d{2}:\d{2}$/.test(tv)) fail("time", "Please choose your arrival time.", timeInput, bad);
      else if (tv < openTime || tv > closeTime) fail("time", `Please choose a time between ${openTime} and ${closeTime}.`, timeInput, bad);
    }
    const name = $("#rv-name"), email = $("#rv-email"), consent = $("#rv-consent");
    if (!name.value.trim()) fail("name", "Please enter your full name.", name, bad);
    if (!email.value.trim()) fail("email", "Please enter your email.", email, bad);
    else if (!email.checkValidity()) fail("email", "Please enter a valid email address.", email, bad);
    if (!consent.checked) fail("consent", "Please tick the box so we can respond to your request.", consent, bad);
    if (summaryErr) { summaryErr.hidden = !bad.length; summaryErr.textContent = bad.length ? `Please check ${bad.length === 1 ? "one thing" : bad.length + " things"} below.` : ""; }
    return bad;
  }

  function payload() {
    const p = selectedPiece(), bo = checked("rv-boutique"), d = dateInput.value, tv = timeInput ? timeInput.value : "";
    const name = $("#rv-name").value.trim(), email = $("#rv-email").value.trim();
    if (!p || !bo || !parseISO(d) || !/^\d{2}:\d{2}$/.test(tv) || !name || !email) return null;
    const o = optionsOf(p.handle);
    if (o.groups.some(g => !g.value)) return null;
    const arrival = `${words(d, true)} (${d})`, phone = $("#rv-phone").value.trim();
    return { piece: `${p.title} (${p.handle})`, options: o.text || "none", boutique: bo.value, arrival, time: tv, name, email, phone: phone || "not given", message: ($("#rv-message")?.value || "").trim(), handle: p.handle, date: d, optValues: o.groups.map(g => g.value) };
  }

  // Hidden fields are kept in step with the choices at all times, so the values are already in the form
  // whenever anything reads it (native submit, Shopify's spam protection, iOS Safari, autofill).
  const hidden = { body: $("[data-rv-body]"), Piece: $('[data-rv-f="Piece"]'), Options: $('[data-rv-f="Options"]'), Boutique: $('[data-rv-f="Boutique"]'), Arrival: $('[data-rv-f="Arrival"]'), "Arrival Time": $('[data-rv-f="Arrival Time"]') };
  function bodyText(v) {
    return ["RESERVATION REQUEST", `Piece: ${v.piece}`, `Options: ${v.options}`, `Boutique: ${v.boutique}`, `Arrival Date: ${v.arrival}`, `Arrival Time: ${v.time}`, `Guest: ${v.name}`, `Email: ${v.email}`, `Phone: ${v.phone}`].concat(v.message ? ["", "Note:", v.message] : []).join("\n");
  }
  function fieldValues(v) {
    return v ? { body: bodyText(v), Piece: v.piece, Options: v.options, Boutique: v.boutique, Arrival: v.arrival, "Arrival Time": v.time } : { body: "", Piece: "", Options: "", Boutique: "", Arrival: "", "Arrival Time": "" };
  }
  function syncHidden() {
    const vals = fieldValues(payload());
    Object.keys(hidden).forEach(k => { if (hidden[k]) hidden[k].value = vals[k]; });
  }

  // Runs first (window, capture phase), before any other script that listens for this form's submit.
  let lastSubmit = 0;
  window.addEventListener("submit", e => {
    if (e.target !== form) return;
    const bad = validate();
    if (bad.length) {
      e.preventDefault(); e.stopImmediatePropagation();
      const first = bad[0].focusEl; if (first) first.focus();
      return;
    }
    if (Date.now() - lastSubmit < 1500) { e.preventDefault(); e.stopImmediatePropagation(); return; }   // no double submit
    lastSubmit = Date.now();
    const v = payload();
    syncHidden();
    store.set({ piece: v.piece.replace(/ \(.*\)$/, ""), options: v.options === "none" ? "" : v.options, boutique: v.boutique, arrival: v.arrival.replace(/ \(.*\)$/, ""), time: v.time, state: { time: v.time, handle: v.handle, optValues: v.optValues, boutique: v.boutique, date: v.date, name: v.name, email: v.email, phone: $("#rv-phone").value.trim(), message: v.message } });
    submitBtn.disabled = true; submitBtn.textContent = "Sending\u2026";
    setTimeout(() => { submitBtn.disabled = false; submitBtn.textContent = "Request this piece"; }, 8000);   // lets the visitor retry if a check was cancelled
  }, true);

  // Whoever builds the form data (the browser, or a script calling new FormData(form)) gets the finished values,
  // and none of the helper inputs used only for picking.
  form.addEventListener("formdata", e => {
    const vals = fieldValues(payload());
    e.formData.set("contact[body]", vals.body);
    ["Piece", "Options", "Boutique", "Arrival", "Arrival Time"].forEach(k => e.formData.set("contact[" + k + "]", vals[k]));
    Array.from(e.formData.keys()).filter(k => k.indexOf("rv-") === 0).forEach(k => e.formData.delete(k));
  });
  ["rv-name", "rv-email", "rv-phone", "rv-message"].forEach(id => { const el = document.getElementById(id); if (el) el.addEventListener("input", syncHidden); });
  if (timeInput) { timeInput.addEventListener("input", syncHidden); timeInput.addEventListener("change", syncHidden); }

  // ---------- Restore what the visitor entered if the server sent them back with errors ----------
  if ($("[data-rv-server-errors]")) {
    const s = store.get(), st = s && s.state;
    if (st) {
      const pi = pieceInputs.find(i => i.value === st.handle); if (pi) { pi.checked = true; showOptions(); }
      const box = $(`[data-rv-opts="${st.handle}"]`);
      if (box) $$("[data-rv-option]", box).forEach((g, i) => { const inp = $$("input", g).find(x => x.value === st.optValues[i]); if (inp) inp.checked = true; });
      const bi = $$('input[name="rv-boutique"]').find(i => i.value === st.boutique); if (bi) bi.checked = true;
      if (st.date) { setDate(st.date); }
      if (timeInput && st.time) { timeInput.value = st.time; recap(); }
      if (!$("#rv-name").value) $("#rv-name").value = st.name || "";
      if (!$("#rv-email").value) $("#rv-email").value = st.email || "";
      $("#rv-phone").value = st.phone || "";
      if ($("#rv-message")) $("#rv-message").value = st.message || "";
    }
    const box = $("[data-rv-server-errors]"); if (box) { box.setAttribute("tabindex", "-1"); box.focus(); }
  }
  showOptions();
  recap();
  updateCount();
})();
